// import styles from './Footer.module.scss';
import React from "react";
import classNames from "classnames";
import styles from "../../../assets/scss/global.module.scss";

interface InputProps {
  label?: string;
  placeholder?: string;
  type?: string;
  value?: any;
  onChange?: any;
  onBlur?: any;
  onKeyDown?: any;
  onPaste?: any;
  error?: string | null;
  name?: string;
  disabled?: boolean;
  inputMode?:
    | "text"
    | "numeric"
    | "decimal"
    | "tel"
    | "search"
    | "email"
    | "url";
  maxLength?: number;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      name = "",
      label = "",
      placeholder = "",
      type = "text",
      value = "",
      onChange,
      onBlur,
      onKeyDown,
      onPaste,
      error,
      disabled = false,
      inputMode,
      maxLength,
    },
    ref
  ) => {
    // console.log(disabled);
    const id = name || label || Math.random().toString(36).slice(2);

    const classNamesForInput = classNames(
      styles["inputContainer"],
      error ? styles["inputError"] : ""
    );

    return (
      <div>
        <div className={classNamesForInput}>
          <label htmlFor={id}>{label}</label>
          <input
            ref={ref}
            id={id}
            name={name}
            type={type}
            placeholder={placeholder}
            value={value || ""}
            onChange={onChange}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            onPaste={onPaste}
            disabled={disabled}
            inputMode={inputMode}
            maxLength={maxLength}
            autoComplete={type === "password" ? "new-password" : type}
          />
          {error && <span className={styles["errorMessage"]}>{error}</span>}
        </div>
      </div>
    );
  }
);

export default Input;
